import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const RENTBURDENDIFF_LAYER_ID = 'rentBurdenDiffLayer';

const layerConfig = {
  title: 'Rent Burden Difference',
};

function RentBurdenDiffLayer() {
  const dispatch = useDispatch();
  const { rentBurdenDiffLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, rentBurdenDiffLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (rentBurdenDiffLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: RENTBURDENDIFF_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: rentBurdenDiffLayer.visible,
      opacity: rentBurdenDiffLayer.opacity,
      getFillColor: colorBins({
        attr: 'rent_burden_diff',
        domain: [-284, 0, 0.01, 50, 100, 200, 485],
        colors: [
          [178, 34, 34],
          [255, 102, 102],
          [224, 224, 255],
          [180, 210, 255],
          [153, 204, 255],
          [51, 153, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: RENTBURDENDIFF_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['rent_burden_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default RentBurdenDiffLayer;
